<template>
  <div class="footer-contain">
    <div class="footer-top">
      <div class="pcLayout text_between">
        <div class="footer-left text_between">
          <img src="@/assets/images/dafaultBgc.png" alt="">
          <div class="footer-left-mes">
            <p>江苏省南京市宁六路219号</p>
            <p>电话: 86-25-58731101 传真: 86-25-57792648</p>
            <p>邮件: xb@nuist.edu.cn</p>
          </div>
        </div>
        <Logo class="footer-logo" :follow_name="'footer'" :name="'logo'"/>
        <div class="footer-right">
<!--          <p>当前访问量：{{ getTodayViews }}</p>-->
<!--          <p>共计访问量：{{ getAllViews }}</p>-->
          <p>访问ip：{{ ip }}</p>
        </div>
      </div>
    </div>
<!--    <div class="footer-bottom" v-if="copyRight">{{ copyRight }}</div>-->
<!--    <div class="footer-bottom" v-else>上海科探信息技术有限公司</div>-->
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import axios from "axios";

export default {
  name: 'myFooter',
  data() {
    return {
      ip: '',
      copyRight: ''
    }
  },
  mounted() {
    setTimeout(() => {
      this.getIp();
    }, 10)
  },
  watch: {
    EnterpriseId: {
      deep: true,
      handler(val) {
        if (val) {
          this.copyRight = this.$store.getters.getUserInfo.enterprise.copyright;
        }
      }
    },
    '$route': {
      immediate: true,
      handler(oldV) {
        if (oldV.name == 'apps') {
          let startDate = new Date(new Date().toLocaleDateString()).getTime() / 1000;
          let endDate = Math.floor((new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1) / 1000);
          this.$store.dispatch('findViewsLength', {startDate, endDate});
          this.$store.dispatch('findViewsLength', {startDate: '', endDate: ''});
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getTodayViews']),
    ...mapGetters(['getAllViews']),
    EnterpriseId() {
      if (this.$store.getters.getUserInfo.enterprise) {
        return this.$store.getters.getUserInfo.enterprise.id;
      } else {
        return '';
      }
    }
  },
  methods: {
    getIp() {
      axios.get(`${window.commonApi.TASKCENTER_API_URL}/api/device/ip`).then(res => {
        this.ip = res.data;
      }).catch(error => {
        console.log(error);
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/myFooter.vue